import { Injectable } from '@angular/core';
import { sha256 } from 'js-sha256';
import { Base64 } from 'js-base64';
import { Observable, from } from 'rxjs';
import { TestBed } from '@angular/core/testing';
import { identifierName } from '@angular/compiler';
import { CookieService } from 'ngx-cookie-service';
import { PurchaseComponent } from '../purchase/purchase.component';
const utf8 = require('utf8');
import { environment } from 'src/environments/environment';

//In order to debug locally,
//  1) run "ng serve" in commerce_app directory
//  2) make sure OnePosServerDebug is running
//  3) make sure OneCashless is running (if you need those services)
//  4) uncomment code in IdealsOneApiService.constructor and writeApiCookie to set cookie with cookie from remote run
//  DO NOT CHECK IN CODE UNCOMMENTED IN #4 above


declare const Faye: any;

let client: any;
let Logger: any;
const handshake = '/meta/handshake';
const subscribe = '/meta/subscribe';
let isSubscribed: boolean;

let apiStore: string;
let token: string;
let key: string;
let group: string;
let profit_center: string;
let cc_merch_id: string;

let responseChannel: string;
let waitTimeReq = '';
let sbsPageInfotData: any;
let sbsSiteInfotData: any;
let sbsAddToCartData: any;
let sbsOrderStatusData: any;
let cancelTimeOut: any;
let messageReceived: any;
let createSignature: any;
let sbsRemoveItemFromOrderData: any;
let sbsupdateQuantityData: any;
let sbsCompleteSaleData: any;
let sbsApplydiscountData: any;
let responseChannelPrefix: string;
let sbsApplyCustomerData: any;
let sbsSavedCardsData: any;
let sbsStoreCCData: any
let sbsCashlessCardsData: any;

@Injectable({
    providedIn: 'root'
})
export class IdealsOneApiService {

    siteId: number;
    env: string;
    clientUrl: string;
    start: any;
    // Client: any;
    api_connect: any;
    payeezy_auth: any;
    tokenization_key: any;
    pageidPassword: any = {};
    constructor(private cookieService: CookieService) {
        // In order to test locally, Uncomment the next line, and use
        // cookie from remote site to set api const in writeApiCookie function in this file
        if ((!environment.production) && (environment.debug)) {
            this.writeApiCookie();
        }
        isSubscribed = false;

        // if (typeof (this.cookieService.get('api_connect')) === 'object') {
        //     this.api_connect = (this.cookieService.get('api_connect'));
        // } else {
        //     this.api_connect = JSON.parse(this.cookieService.get('api_connect'));
        // }

        console.debug('[constructor] api_connect', this.cookieService.get('api_connect'));
        console.info('[constructor] payeezy_auth', this.cookieService.get('payeezy_auth'));

        this.api_connect = JSON.parse(this.cookieService.get('api_connect'));
        this.payeezy_auth = JSON.parse(this.cookieService.get('payeezy_auth'));

        cc_merch_id = this.payeezy_auth.cc_merch_id;
        console.info('[constructor] tokenization key: ' + cc_merch_id);
        // Use this tokenization key in CollectJS script
        this.tokenization_key = cc_merch_id;

        apiStore = this.api_connect.api;
        group = this.api_connect.group;
        token = this.api_connect.token;
        key = this.api_connect.key;
        this.siteId = this.api_connect.location_id;
        this.env = this.api_connect.env;
        this.clientUrl = this.api_connect.client_url;
        profit_center = this.api_connect.profit_center ? this.api_connect.profit_center : '';

        responseChannelPrefix = '/' + apiStore + '/' + group + '/' + this.siteId;
        console.info('[constructor] responseChannelPrefix', responseChannelPrefix);
        this.start = new Date().getTime();
        // Connect To Faye
        client = new Faye.Client(this.clientUrl, {
            timeout: 120
        });

        client.connect();
        client.disable('WebSocket');

        const SubscribeIt = (rc: any) => {
            let msg: any;
            client.subscribe(rc, function (message: any) {
                console.debug('subscribed data', message);
                msg = message;

                if (msg.data.message === waitTimeReq) {
                    messageReceived = message;
                    switch (msg.data.message) {
                        case 'page_information': {
                            sbsPageInfotData = message;
                            cancelTimeOut();
                            break;
                        }
                        case 'site_information': {
                            sbsSiteInfotData = message;
                            sessionStorage['siteInformations'] = JSON.stringify(sbsSiteInfotData);
                            // cancelTimeOut();
                            break;
                        }
                        case 'add_item_to_order': {
                            sbsAddToCartData = message;
                            console.debug('[subscription] add_item_to_order', sbsAddToCartData);
                            cancelTimeOut();
                            break;
                        }
                        case 'order_status': {
                            sbsOrderStatusData = message;
                            console.debug('[subscription] order_status', sbsOrderStatusData);
                            cancelTimeOut();
                            break;
                        }
                        case 'remove_item_from_order': {
                            sbsRemoveItemFromOrderData = message;
                            console.debug('[subscription] sbsRemoveItemFromOrderData', sbsRemoveItemFromOrderData);
                            cancelTimeOut();
                            break;
                        }
                        case 'update_quantity': {
                            sbsupdateQuantityData = message;
                            console.debug('[subscription] update_quantity', sbsupdateQuantityData);
                            cancelTimeOut();
                            break;
                        }
                        case 'complete_sale': {
                            sbsCompleteSaleData = message;
                            console.debug('[subscription] complete_sale', sbsCompleteSaleData);
                            cancelTimeOut();
                            break;
                        }
                        case 'apply_discount': {
                            sbsApplydiscountData = message;
                            console.debug('[subscription] apply_discount', sbsApplydiscountData);
                            cancelTimeOut();
                            break;
                        }
                        case 'apply_customer': {
                            sbsApplyCustomerData = message;
                            console.debug('[subscription] apply_customer', sbsApplyCustomerData);
                            cancelTimeOut();
                            break;
                        }
                        case 'store_credit_card': {
                            sbsStoreCCData = message;
                            console.debug('[subscription] store_credit_card', sbsStoreCCData);
                            cancelTimeOut();
                            break;
                        }
                        case 'list_stored_credit_cards': {
                            sbsSavedCardsData = message;
                            console.debug('[subscription] list_stored_credit_cards', sbsSavedCardsData);
                            cancelTimeOut();
                            break;
                        }
                        case 'list_cards': {
                            sbsCashlessCardsData = message;
                            console.debug('[subscription] list_cards', sbsCashlessCardsData);
                            cancelTimeOut();
                            break;
                        }
                        default: {
                            console.error('[subscription] Unknown message received', message);
                            break;
                        }
                    }
                }
                return message;
                // }).then(function (msg: any) {
            }).then(function () {
                console.info('[client] subscription successful');
                isSubscribed = true;

                // starttest 04-20-2020
                // PurchaseComponent.prototype.siteInformation();
                const siteInformationObservable = IdealsOneApiService.prototype.siteInformationReq();
                siteInformationObservable.subscribe((siteInformationData: any) => {
                    if (siteInformationData !== undefined) {
                        sessionStorage['siteInformations'] = JSON.stringify(siteInformationData);
                        console.debug('[subscription] site_information', siteInformationData);
                    } else {
                        sessionStorage.removeItem('siteInformations');
                    }
                    // sessionStorage['siteInformations'] = JSON.stringify(siteInformationData);
                });
            }, function (error: any) {
                console.error('Error subscribing', error.message);
            });

        };

        Logger = {
            incoming: function (message: any, callback: any) {
                console.debug('[extension] incoming message', message);
                if (message.channel === handshake && message.successful) {
                    const obj = JSON.parse(JSON.stringify(message));
                    const clientID = (obj.clientId);
                    console.info('[extension] clientID', clientID);
                    responseChannel = '/' + apiStore + '/' + group + '/' + clientID + '/response_channel';
                    console.info('[extension] responseChannel:' + responseChannel);
                    messageReceived = {
                        data: {
                            message: 'connect'
                        }
                    };
                    if (!isSubscribed) {
                        SubscribeIt(responseChannel);
                    }
                }
                return callback(message);
            },
            outgoing: function (message: any, callback: any) {
                if (message) {
                    console.debug('[extension] outgoing message', message);
                    try {
                        let evl = {};
                        const jsonString = JSON.stringify(message);
                        const json = message;
                        if (message.channel === subscribe) {
                            const salt = random128();
                            evl = {
                                'api': apiStore,
                                'token': token,
                                'salt': Base64.encode(salt),
                                'signature': createSignature(salt, jsonString),
                                'message': subscribe,
                                'data': Base64.encode(jsonString),
                                'profit_center': profit_center
                            };
                            message.ext = evl;
                            console.debug('[extension] payload', evl);
                            return callback(message);
                        }

                        if (json.data !== 'undefined' && json.data != null) {
                            const salt = random128();
                            let message1: any;
                            if ((json != null) && (json.data != null)) {
                                message1 = json.data.message;
                            } else {
                                console.error('[extension] outgoing message missing data', json.data);
                            }

                            evl = {
                                'api': apiStore,
                                'token': token,
                                'salt': Base64.encode(salt),
                                'signature': createSignature(salt, jsonString),
                                'message': json.data.message,
                                'data': Base64.encode(jsonString),
                                'profit_center': profit_center
                            };
                            message.ext = evl;
                            message.data = json.data;
                        }
                    } catch (err) {
                        console.error('[extension] Error: ', err);
                    }
                }

                callback(message);
            }
        };

        client.addExtension(Logger);

        // signature
        createSignature = (salt: any, json: any) => {
            const signature = (sha256(sha256(sha256(utf8.encode(json)) + utf8.encode(key)) + (salt)));
            // console.log('signature', signature);
            return signature;
        };

        // random128
        function random128() {
            let result = '';
            for (let i = 0; i < 8; i++) {
                let tStr = '\udfc9';
                while (tStr === '\udfc9') {
                    tStr = String.fromCharCode(Math.random() * 0xF);
                }
                result += tStr;
            }
            return result;
        }
    }


    // Set Cookies when debugging
    writeApiCookie() {  // NOTE: This is only called in the cookieService constructor if uncommented there, otherwise this is dead code
        // const api: any = {
        //     'token': 'E34E53B30519B2D6B4A57D0EC902EDECB07F31B4E67CA3823D9725AC746BBBA1',
        //     // tslint:disable-next-line:max-line-length
        //     'key': 'AE7780BDC99BAC1A5DB66C52F5EDD48EEB87126CE404C529D0FAF8F9F601E21A462EC8B1B824F0DC36891200B4EB2AB71FFD50D6FED4108216F83132A65E5CF0',
        //     'group': '480',
        //     'api': 'one_api',
        //     'client_url': 'https://pubsub-test.idealss.net',
        //     'location_id': 30467,
        //     'env': 'development',
        //     'title': 'Chetu, Inc.',
        //     'profit_center': 'commerce-test-site'
        // };
        //uncomment const below to test/debug locally on jake's PC
        // const api: any = { "token": "043f2653a87aee207da4399fac366bcbc26e334590707e1f5e20fe940c3aaa382742fc3cccea471e5021cf8551bca4eefa89a12b1f551bd439ed5dcf56090f03", "key": "be58898ed86e248884f930264c7d85e59edeffa9cd139661df0133128789caa57645c2982e9c582d1ecaec2843294ebd54deae391c9e98d70072558c553b51b0c32c82cf6ccf0cf5dd3a1a9d7145b39890ec2d02851ca18caad4ff5d292a9aba10a092f1cd361b93eafc869aafc9265d1136371fbc1c8020f51de19ebdb1e7f6", "group": 541, "api": "one_api", "client_url": "https://pubsub-test.idealss.net", "report_url": "https://site1commerce.test.idealss.net/report_a_problem", "location_url": "site1commerce", "location_id": 31086, "tac_url": "https://static.test.idealss.net/", "title": "RW-", "env": "development", "profit_center": "site1commerce" };
        // const payeezyAuth: any = { "processor_type": 1, "payeezy_key": "", "api_key": "BjemM2tQeKjJVZm6GSQcEyMEEEPpEed8", "ta_token": "", "cc_api_key": null, "cc_merch_id": "800000000175" }

        this.cookieService.set('api_connect', JSON.stringify(environment.api_connect));
        this.cookieService.set('payeezy_auth', JSON.stringify(environment.payeezy_auth));

        // console.log('Cookies-----API_CONNECT---:' + this.cookieService.get('api_connect'));
        // console.log('Cookies-----PAYEEZY_AUTH---:' + this.cookieService.get('payeezy_auth'));
    }

    // page_information
    pageInformationReq(pageId: any) {
        const data = this.pageInformation(pageId);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info(`[page_information_req] Successfully published request for page id ${pageId.pageId}!`);
            waitTimeReq = 'page_information';
        }, function (error: any) {
            console.error('[page_information_req] Error publishing: ' + error);
        });
        const pageInfoObservable = new Observable(observer => {
            const pageInfoObsTimeout = () => {
                observer.next(sbsPageInfotData);
            };
            const pageInfoTimer = setTimeout(pageInfoObsTimeout, 10000);
            cancelTimeOut = () => {
                clearTimeout(pageInfoTimer);
                observer.next(sbsPageInfotData);
            };
        });

        return pageInfoObservable;
    }


    // page_information
    pageInformation(pageId: any) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'page_information',
            'detail': {
                'page_id': pageId.pageId,
                'password': pageId.password,
                'reservation_date': pageId.reservation_date
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // site_information
    siteInformationReq() {
        const data = this.siteInformation();
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[site_information_req] Successfully published!');
            waitTimeReq = 'site_information';
        }, function (error: any) {
            console.error('[site_information_req] Error publishing: ' + error.message);
        });

        const siteInfoObservable = new Observable(observer => {
            const siteInfoObsTimeout = () => {
                observer.next(sbsSiteInfotData);
            };
            const siteInfoTimer = setTimeout(siteInfoObsTimeout, 1000);
            cancelTimeOut = () => {
                clearTimeout(siteInfoTimer);
                observer.next(sbsSiteInfotData);
            };
        });

        return siteInfoObservable;

    }

    // site_information
    siteInformation() {
        const data = {
            'message': 'site_information',
            'detail': {},
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // order_statusReq
    orderStatusReq() {
        const data = this.orderStatus();
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[order_status_req] Successfully published!');
            waitTimeReq = 'order_status';
        }, function (error: any) {
            console.error('[order_status_req] Error publishing: ' + error.message);
        });
        const orderStatusObservable = new Observable(observer => {
            const orderStatusObsTimeout = () => {
                observer.next(sbsOrderStatusData);
            };
            const orderStatusTimer = setTimeout(orderStatusObsTimeout, 60000);
            cancelTimeOut = () => {
                clearTimeout(orderStatusTimer);
                observer.next(sbsOrderStatusData);
            };
        });

        return orderStatusObservable;
    }

    // order_status
    orderStatus() {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'order_status',
            'detail': {
                'detailed': true
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }


    // add_item_to_order
    // addItemToOrderReq(quantity: number, itemNumber: any) {
    //     const data = this.addItemToOrder(quantity, itemNumber);
    //     const publication = client.publish(responseChannelPrefix, data).then(function () {
    //         console.log('Successfully published!');
    //         waitTimeReq = 'add_item_to_order';
    //     }, function (error: any) {
    //         console.log('Error publishing: ' + error.message);
    //     });
    //     const addItemToOrderObservable = new Observable(observer => {
    //         const addItemToOrderObsTimeout = () => {
    //             observer.next(sbsAddToCartData);
    //         };
    //         const addItemToOrderTimer = setTimeout(addItemToOrderObsTimeout, 60000);
    //         cancelTimeOut = () => {
    //             clearTimeout(addItemToOrderTimer);
    //             observer.next(sbsAddToCartData);
    //         };
    //     });

    //     return addItemToOrderObservable;
    // }

    addItemToOrderReq(isReserev, quantity, itemNumber, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, addSpecialInstructions, selectedNestedItems) {
        const data = this.addItemToOrder(isReserev, quantity, itemNumber, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, addSpecialInstructions, selectedNestedItems);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[add_item_to_order_req] Successfully published!');
            waitTimeReq = 'add_item_to_order';
        }, function (error: any) {
            console.error('[add_item_to_order_req] Error publishing: ' + error.message);
        });
        const addItemToOrderObservable = new Observable(observer => {
            const addItemToOrderObsTimeout = () => {
                observer.next(sbsAddToCartData);
            };
            const addItemToOrderTimer = setTimeout(addItemToOrderObsTimeout, 60000);
            cancelTimeOut = () => {
                clearTimeout(addItemToOrderTimer);
                observer.next(sbsAddToCartData);
            };
        });

        return addItemToOrderObservable;
    }

    // add_item_to_order
    // addItemToOrder(quantity: number, itemNumber: any) {
    //     const messageid = this.createGuid();
    //     const currenttimestamp = this.createDate();
    //     const data = {
    //         'message': 'add_item_to_order',
    //         'detail': {
    //             'item_number': itemNumber,
    //             'quantity': quantity,
    //         },
    //         'response_channel': responseChannel,
    //         'session': token
    //     };
    //     return data;
    // }

    // add_item_to_order
    addItemToOrder(isReserev, quantity, itemNumber, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, addSpecialInstructions, selectedNestedItems) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'add_item_to_order',
            'detail': {
                'item_number': itemNumber,
                'quantity': quantity,
                'add_suggested_modifiers': addSuggestedModifiers,
                'add_modifiers': addModifiers,
                'delivery_location': deliveryLocation,
                'delivery_type': deliveryType,
                'add_special_instructions': addSpecialInstructions,
                'reserve': {
                    'date': isReserev.date,
                    'time': isReserev.time
                },
                'items': selectedNestedItems
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // update_quantity
    updateQuantityReq(quantity: number, itemId: any) {
        const data = this.updateQuantity(quantity, itemId);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[update_quantity_req] Successfully published!');
            waitTimeReq = 'update_quantity';
        }, function (error: any) {
            console.error('[update_quantity_req] Error publishing: ' + error.message);
        });
        const updateQuantityObservable = new Observable(observer => {
            const updateQuantityObsTimeout = () => {
                observer.next(sbsupdateQuantityData);
            };
            const updateQuantityTimer = setTimeout(updateQuantityObsTimeout, 40000);
            cancelTimeOut = () => {
                clearTimeout(updateQuantityTimer);
                observer.next(sbsupdateQuantityData);
            };
        });
        return updateQuantityObservable;
    }

    // update_quantity
    updateQuantity(quantity: number, itemId: any) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'update_quantity',
            'detail': {
                'id': itemId,
                'quantity': quantity
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // remove_item_from_order
    removeItemFromOrderReq(itemId: any) {
        const data = this.removeItemFromOrder(itemId);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[remove_item_from_order_req] Successfully published!');
            waitTimeReq = 'remove_item_from_order';
        }, function (error: any) {
            console.error('[remove_item_from_order_req] Error publishing: ' + error.message);
        });
        const removeItemFromOrderObservable = new Observable(observer => {
            const removeItemFromOrderObsTimeout = () => {
                observer.next(sbsRemoveItemFromOrderData);
            };
            const removeItemFromOrderTimer = setTimeout(removeItemFromOrderObsTimeout, 40000);
            cancelTimeOut = () => {
                clearTimeout(removeItemFromOrderTimer);
                observer.next(sbsRemoveItemFromOrderData);
            };
        });
        return removeItemFromOrderObservable;
    }

    // remove_item_from_order
    removeItemFromOrder(itemId: any) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'remove_item_from_order',
            'detail': {
                'id': itemId
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // apply_discount
    applyDiscountReq(offerCode: any) {
        const data = this.applyDiscount(offerCode);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[apply_discount_req] Successfully published!');
            waitTimeReq = 'apply_discount';
        }, function (error: any) {
            console.error('[apply_discount_req] Error publishing: ' + error.message);
        });
        const applyDiscountObservable = new Observable(observer => {
            const applyDiscountObsTimeout = () => {
                observer.next(sbsApplydiscountData);
            };
            const applyDiscountTimer = setTimeout(applyDiscountObsTimeout, 30000);
            cancelTimeOut = () => {
                clearTimeout(applyDiscountTimer);
                observer.next(sbsApplydiscountData);
            };
        });

        return applyDiscountObservable;
    }

    // apply_discount
    applyDiscount(offerCode: any) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'apply_discount',
            'detail': {
                'code': offerCode.offerCode
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // complete_sale
    completeSaleReq(ccFormData: any, pageId: any, payment_token: any, add_tip: any, routing_override: any) {
        const data = this.completeSale(ccFormData, pageId, payment_token, add_tip, routing_override);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[complete_sale_req] Successfully published!');
            waitTimeReq = 'complete_sale';
        }, function (error: any) {
            console.error('[complete_sale_req] Error publishing: ' + error.message);
        });
        const completeSaleObservable = new Observable(observer => {
            const completeSaleObsTimeout = () => {
                console.error('completeSale request timed out');
                observer.next(sbsCompleteSaleData);
            };
            const completeSaleTimer = setTimeout(completeSaleObsTimeout, 180000);
            cancelTimeOut = () => {
                clearTimeout(completeSaleTimer);
                observer.next(sbsCompleteSaleData);
            };
        });

        return completeSaleObservable;
    }

    // complete sell
    completeSale(ccFormData: any, pageId: any, payment_token: any, add_tip: any, routing_override: any) {
        console.info('completeSale.pageId=' + pageId);
        console.info('completeSale.payment_token=' + payment_token);
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        let expYearStr = '';
        if (ccFormData.expYear.length > 3) {
            expYearStr = (ccFormData.expYear).substr(2, 2);
        } else { expYearStr = (ccFormData.ccexp).substr(3, 2); }
        let expMonthStr = '';
        if (ccFormData.expMonth.length > 0) {
            expMonthStr = ccFormData.expMonth;
        } else { expMonthStr = (ccFormData.ccexp).substr(0, 2); }
        const data = {
            'message': 'complete_sale',
            'detail': {
                'customer_email': ccFormData.email,
                'customer_sms': ccFormData.phone,
                'first_name': ccFormData.fName,
                'last_name': ccFormData.lName,
                'home_phone': '',
                'city': ccFormData.city,
                'state': sessionStorage['state'],
                'postal_code': ccFormData.zipCode,
                'country': sessionStorage['country'],
                'payment_token': payment_token,
                'customer_name': ccFormData.nameOnCreditCard,
                'first_6': ccFormData.first_6,
                'last_4': ccFormData.last_4,
                'account_number': '0',
                'exp_month': expMonthStr,
                'exp_year': expYearStr,
                'brand': ccFormData.cardType,
                'page_id': pageId,
                'add_tip': add_tip,
                'routing_override': routing_override,
                'payment_cashless_cardid': ccFormData.card_id,
                'payment_saved_card_id': ccFormData.cCardId,
                'web_verification': {
                    'cavv': sessionStorage.getItem('cavv'),
                    'xid': sessionStorage.getItem('xid'),
                    'eci': sessionStorage.getItem('eci'),
                    'cardHolderAuth': sessionStorage.getItem('cardHolderAuth'),
                    'threeDsVersion': sessionStorage.getItem('threeDsVersion'),
                    'directoryServerId': sessionStorage.getItem('directoryServerId')
                },
                'items_updated_info': [{
                    'item_number': '',
                    'address': ccFormData.streetAddress,
                    'address_2': '',
                    'city': ccFormData.cityCard,
                    'state': sessionStorage['state'],
                    'postal_code': ccFormData.zipCode,
                    'phone_home': '',
                    'phone_work': '',
                    'phone_mobile': ccFormData.phone,
                    'image': '',
                    'sms_opt_in': ccFormData.phoneOptIn,
                    'email_opt_in': ccFormData.emailOptIn
                }]
            },
            'response_channel': responseChannel,
            'session': token
        };
        console.debug('completeSale: Outgoing Data', data);
        return data;
    }

    // currentdatetime
    createDate() {
        const currentdate = new Date();
        const currentDateTime = currentdate.toISOString();
        // var currentDateTime = (currentdate.toLocaleString()).replace(',', '');
        return currentDateTime;
    }

    // guid
    createGuid() {
        function _p8(s) {
            const p = (Math.random().toString(16) + '000000000').substr(2, 8);
            return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
        }
        return _p8(false) + _p8(true) + _p8(true) + _p8(false);
    }

    // apply_customerReq
    applyCustomerReq(email: any, phone: any, code: any) {

        const data = this.applyCustomer(email, phone, code);
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[apply_customer_req] Successfully published!');
            waitTimeReq = 'apply_customer';
        }, function (error: any) {
            console.error('[apply_customer_req] Error publishing: ' + error.message);
        });
        const applyCustomerObservable = new Observable(observer => {
            const applyCustomerObsTimeout = () => {
                observer.next(sbsApplyCustomerData);
            };
            const applyCustomerTimer = setTimeout(applyCustomerObsTimeout, 5000);
            cancelTimeOut = () => {
                clearTimeout(applyCustomerTimer);
                observer.next(sbsApplyCustomerData);
            };
        });

        return applyCustomerObservable;
    }

    // apply_customer
    applyCustomer(email: any, phone: any, code: any) {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'apply_customer',
            'detail': {
                'email_address': email,
                'phone_number': phone,
                'code': code
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    // cashlessCardReq
    cashlessCardReq() {

        const data = this.cashlessCards();
        const publication = client.publish(responseChannelPrefix, data).then(function () {
            console.info('[cashless_card_req] Successfully published!');
            waitTimeReq = 'list_cards';
        }, function (error: any) {
            console.error('[cashless_card_req] Error publishing: ' + error.message);
        });
        const cashlessCardsObservable = new Observable(observer => {
            const cashlessCardsObsTimeout = () => {
                observer.next(sbsCashlessCardsData);
            };
            const cashlessCardsTimer = setTimeout(cashlessCardsObsTimeout, 5000);
            cancelTimeOut = () => {
                clearTimeout(cashlessCardsTimer);
                observer.next(sbsCashlessCardsData);
            };
        });

        return cashlessCardsObservable;
    }

    // cashlessCards
    cashlessCards() {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'list_cards',
            'detail': {
                'detailed': true
            },
            'response_channel': responseChannel,
            'session': token
        };

        return data;
    }

    // savedCardsReq
    savedCreditCardReq() {

        const data = this.savedCards();
        const publication = client.publish(responseChannelPrefix, data).then(function (res) {

            console.info('[saved_credit_card_req] Successfully published!', res);
            waitTimeReq = 'list_stored_credit_cards';
        }, function (error: any) {
            console.error('[saved_credit_card_req] Error publishing: ' + error.message);
        });
        const savedCardsObservable = new Observable(observer => {
            const savedCardsObsTimeout = () => {
                observer.next(sbsSavedCardsData);
            };
            const savedCardsTimer = setTimeout(savedCardsObsTimeout, 2000);
            cancelTimeOut = () => {
                clearTimeout(savedCardsTimer);
                observer.next(sbsSavedCardsData);
            };
        });

        return savedCardsObservable;
    }

    // saved_cards API
    savedCards() {
        const messageid = this.createGuid();
        const currenttimestamp = this.createDate();
        const data = {
            'message': 'list_stored_credit_cards',
            'detail': {
                'detailed': true
            },
            'response_channel': responseChannel,
            'session': token
        };
        return data;
    }

    //store_credit_card request
    storeCreditCardReq(aliasName, cardType, ccToken, nameOnCCard, First6, Last4, expMonth, expYear2, postalCode) {
        const data = this.storeCreditCard(aliasName, cardType, ccToken, nameOnCCard, First6, Last4, expMonth, expYear2, postalCode);
        const publication = client.publish(responseChannelPrefix, data).then(function () {

            console.info('[store_credit_card_req] Successfully published!');
            waitTimeReq = 'store_credit_card';
        }, function (error: any) {
            console.error('[store_credit_card_req] Error publishing: ' + error.message);
        });
        const storeCreditCardObservable = new Observable(observer => {
            const storeCreditCardObsTimeout = () => {
                observer.next(sbsStoreCCData);
            };
            const storeCreditCardTimer = setTimeout(storeCreditCardObsTimeout, 2000);
            cancelTimeOut = () => {
                clearTimeout(storeCreditCardTimer);
                observer.next(sbsStoreCCData);
            };
        });

        return storeCreditCardObservable;
    }

    // store_credit_card
    storeCreditCard(aliasName, cardType, ccToken, nameOnCCard, First6, Last4, expMonth, expYear2, postalCode) {
        var data = {
            "message": "store_credit_card",
            "detail": {
                "alias": aliasName,
                "payment_token": ccToken,
                "customer_name": nameOnCCard,
                "first_6": First6,
                "last_4": Last4,
                "account_number": "",
                "exp_month": expMonth,
                "exp_year": expYear2,
                "brand": cardType,
                "postal_code": postalCode
            },
            "response_channel": responseChannel,
            "session": token
        }
        return data;
    }

}
